import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from "../../../../axiosinterceptor";

const initialState = {
  coderCard:{
    documentationCard: true,
    codingScreenCard: true,
    codeBookCard: true
  },
  auditStatusState : {
    auditStatusLoading: false,
    auditStatusStateData: {},
    auditStatusStateError: null,
  },
clusterCodeWarnings: {
  clusterCodeWarningsIsLoading: false,
  clusterCodeWarningsList: [],
  clusterCodeWarningsError: null,
},
cancerCodeWarnings: {
  cancerCodeWarningsIsLoading: false,
  cancerCodeWarningsList: [],
  cancerCodeWarningsError: null,
},
    auditorNamesandQueues:[],
    loadingAuditorNamesandQueues:false,
    errorsauditorNamesandQueues:null,
    coderNamesInActions:[],
    loadingcoderNamesInActions:false,
    errorcoderNamesInActions:null,
  episodesData: [],
  isEpisodesLoading: false,
  episodeError: null,
  drgOptionsData: [],
  loadingDrgOptionsData: false,
  errorsDrgOptionsData: null,
  drgInformation: [],
  loadingDrgInformation: true,
  errorsDrgInformation: null,
  triggerpallascdc:[],
  triggerpallascdcLoading:false,
  errortriggerpallascdc:null,
  injuryWithActivity: [], // S00 – T65
  externalCauseCodes: [], // V00 – Y91 and Y95-Y98
  placeOfOccurrence: [], // Y92.0 – Y92.89
  activityCodes: [], // U50.0 - U73.81
  injuryWithoutActivity: [],
  chronicCodes: [],
  clusterIDs:[],
  currentClusterID: '',
  isPallasAlgoApplied:false,
  nextClusterIDs: [],
    rangesLoaded: {
    injuryWithActivity: false,
    externalCauseCodes: false,
    placeOfOccurrence: false,
    activityCodes: false,
    injuryWithoutActivity: false,
    injuries: false,
    burns: false,
    frostbite: false,
    poisoning: false,
    effectsOfExternalCauses: false,
    earlyComplicationsOfTrauma: false,
    complicationOfSurgicalAndMedicalCare: false,
    otherComplicationOfTrauma: false,
    sequelaeOfInjuries: false,
    chronicCodes: false
  },
  selectedMissingNotesOptions: { 
    reasons: [],
    additional_comments : []
  },
  enableMissingNotes: false, 
  showMissningNotesDropdown: false
};
export const fetchEpisodes = createAsyncThunk(
  "coder/fetchEpisodes",
  async (episodeListFilterObj, { rejectWithValue }) => {
      try {
        const response = await axiosInstance.post(
            "/Filter_navigation_acs",
            episodeListFilterObj
        );
        const data = response?.data;
          return data.episode;
      } catch (error) {
          return rejectWithValue(error.message);
      }
  }
);
export const fetchDrgOptions = createAsyncThunk(
  "coder/fetchDrgOptions",
  async (payload,{ rejectWithValue }) => {
      try {
          const response = await axiosInstance.post(
              "/drg_options",
              payload
          );
          console.log(response,'drgopt');
          
          return response.data;
      } catch (error) {
          return rejectWithValue(error.message);
      }
  }
);
export const triggerPallasAlgoCdc = createAsyncThunk(
  "coder/triggerPallasAlgoCdc",
  async (payload,{ rejectWithValue }) => {
      try {
          const response = await axiosInstance.post(
              "/pallas_algo_cdc",
              payload
          );
          console.log(response,'drgopt');
          
          return response.data;
      } catch (error) {
          return rejectWithValue(error.message);
      }
  }
);
export const fetchAllCodesbyStepFunction = createAsyncThunk(
  "coder/fetchAllCodesbyStepFunction",
  async (payload,{ rejectWithValue }) => {
      const new_hcp_line_id = sessionStorage.getItem("last_epi_identifier");
      const case_mix_speciality=sessionStorage.getItem("case_mix_speciality");
      try {
          const response = await axiosInstance.post(
              "https://cqpqzxetra.execute-api.ap-southeast-2.amazonaws.com/agent_step_function/agentic_step_functions",
              {
                episode_id:new_hcp_line_id,
                case_mix:case_mix_speciality
              }
          );
          console.log(response,'drgopt');
          
          return response.data;
      } catch (error) {
          return rejectWithValue(error.message);
      }
  }
);
export const fetchAllCodesProgress = createAsyncThunk(
  "coder/fetchPrincipalDiagnosisCodes",
  async (payload,{ rejectWithValue }) => {
      try {
          const response = await axiosInstance.post(
              "https://1qwtwtzbci.execute-api.ap-southeast-2.amazonaws.com/agentic_step_function_status ",
              {
                executionArn:payload
              }
          );
          return response.data;
      } catch (error) {
          return rejectWithValue(error.message);
      }
  }
);
export const fetchDrgInformation =createAsyncThunk(
    "coder/fetchDrgInformation",
    async (payload,{ rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(
                "/drg_grouping_additional_information",
                payload
            );
            // console.log(response,'drgopt');
            
            return response.data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
  );

  export const getAuditResponse = createAsyncThunk(
    '/getAuditResponse',
    async (payload, { fulfillWithValue, rejectWithValue }) => {
      try {
        const response = await axiosInstance.get(`/get_audit_log?hcp_line_id=${payload.hcp_line_id}&episode_identifier=${payload.episode_identifier}`);
        const lines = response?.data?.body?.replace(/\\n/g, '\n')?.split('\n');
          // console.log(response?.data?.body, 'lines')
        const parsedData = {};
        lines.forEach(line => {
          const [key, value] = line?.split(':')?.map(s => s?.trim());
          parsedData[key] = value;
        });
        
        console.log(parsedData, 'parsedData');
        return fulfillWithValue(parsedData);
      } catch (error) {
        console.error('Error fetching Audit Details:', error);
        return rejectWithValue(error.response?.data?.message || error.message || "No data found");
      }
    }
  );

  export const fetchClusterWarnings = createAsyncThunk(
  "coder/fetchClusterWarnings",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
      try {
        const response = await axiosInstance.post(
            "/code_assist_dcid_warnings",
            payload
        );
        const fetchedWarningsData = response?.data;
        // console.log(fetchedWarningsData, 'fetchedWarningsData121')
          return fulfillWithValue(fetchedWarningsData);
      } catch (error) {
        console.log(error, 'errorcluster')
          return rejectWithValue(error?.response?.data?.message);
      }
  }
);

// Fetch cancer warnings

  export const fetchCodeAssistCancerWarnings = createAsyncThunk(
  "fetchCodeAssistCancerWarnings",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
      try {
        const response = await axiosInstance.post(
            "/code_assist_cancer_warnings",
            payload
        );
        const fetchedWarningsData = response?.data;
          return fulfillWithValue(fetchedWarningsData);
      } catch (error) {
        console.log(error, 'error while fetching cancer warnings')
          return rejectWithValue(error?.response?.data?.message);
      }
  }
);
export const getAuditorNamesAndQueues = createAsyncThunk(
  "coder/getAuditorNamesAndQueues",
  async (_, thunkAPI) => {
    try {
      const response = await axiosInstance.get(
        '/send_to_auditor_options'
      );
      console.log("Queue Fil API Response", response.data);

      // Remove JSON.parse, since response.data is already an object
      return response.data;
    } catch (error) {
      console.error("Error fetching queue list:", error); // Log errors too
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to fetch queue list"
      );
    }
  }
);
export const getCoderNamesInActions = createAsyncThunk(
  "coder/getCoderNamesInActions",
  async (_, thunkAPI) => {
    try {
      const response = await axiosInstance.get(
        '/for_review_coders'
      );
      console.log("Queue Fil API Response", response.data);

      // Remove JSON.parse, since response.data is already an object
      return response.data;
    } catch (error) {
      console.error("Error fetching queue list:", error); // Log errors too
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to fetch queue list"
      );
    }
  }
);
export const getunlockEpisode = createAsyncThunk(
  "coder/unlockEpisode",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
       "/unlock_episode",
        payload
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message
      );
    }
  }
);

const coderSlicer = createSlice({
  name: "coderSlicer",
  initialState,
  reducers: {
    setDocumentationCard: (state, action) => {
        state.coderCard.documentationCard = action.payload;
    },
    setCodingScreenCard: (state, action) => {
        state.coderCard.codingScreenCard = action.payload;
    },
    setCodeBookCard: (state, action) => {
        state.coderCard.codeBookCard = action.payload;
    },
    setRangeChildren: (state, action) => {
      const { rangeType, children } = action.payload;
      state[rangeType] = children;
      state.rangesLoaded[rangeType] = true;
    },
    setClusterIDs: (state, action) => {
        state.clusterIDs = action.payload;
    },
    setcurrentClusterID: (state, action) => {
        state.currentClusterID = action.payload;
    },
    setNextClusterIDs: (state, action) => {
      state.nextClusterIDs = action.payload;
    },
    setClusterCodeWarningsList: (state) => {
      state.clusterCodeWarnings.clusterCodeWarningsList = []
    }, 
    setCancerCodeWarningsList: (state) => {
      state.cancerCodeWarnings.cancerCodeWarningsList = []
    }, 
    setEnableMissingNotes: (state, action) => {
      state.enableMissingNotes = action.payload
    },
    setShowMissningNotesDropdown: (state, action) => {
      state.showMissningNotesDropdown = action.payload
    },
    setSelectedMissingNotesOptions: (state, action) => {
      state.selectedMissingNotesOptions = action.payload
    }, 
    resetSelectedMissingNotesOptions: (state) => {
      state.selectedMissingNotesOptions = 
      { reasons: [], additional_comments: [] 

      }
    },
    setIsPallasAlgoApplied: (state) => {
      state.isPallasAlgoApplied = true;
    },
    resetIsPallasAlgoApplied: (state) => {
      state.isPallasAlgoApplied = false;
    },
  },
  extraReducers: (builder) => {
    builder
        .addCase(fetchEpisodes.pending, (state) => {
            state.isEpisodesLoading = true;
            state.episodeError = null;
        })
        .addCase(fetchEpisodes.fulfilled, (state, action) => {
            state.isEpisodesLoading = false;
            state.episodesData = action.payload;
        })
        .addCase(fetchEpisodes.rejected, (state, action) => {
            state.isEpisodesLoading = false;
            state.episodeError = action.payload;
        })
        .addCase(fetchDrgOptions.pending, (state) => {
          state.loadingDrgOptionsData = true;
          state.errorsDrgOptionsData = null;
      })
      .addCase(fetchDrgOptions.fulfilled, (state, action) => {
          state.loadingDrgOptionsData = false;
          state.drgOptionsData = action.payload;
      })
      .addCase(fetchDrgOptions.rejected, (state, action) => {
          state.loadingDrgOptionsData = false;
          state.errorsDrgOptionsData = action.payload;
      })
      .addCase(fetchDrgInformation.pending, (state) => {
        state.loadingDrgInformation = true;
        state.errorsDrgInformation = null;
    })
    .addCase(fetchDrgInformation.fulfilled, (state, action) => {
        state.loadingDrgInformation = false;
        state.drgInformation = action.payload;
    })
    .addCase(fetchDrgInformation.rejected, (state, action) => {
        state.loadingDrgInformation = false;
        state.errorsDrgInformation = action.payload;
    })
    .addCase(triggerPallasAlgoCdc.pending, (state) => {
        state.triggerpallascdcLoading = true;
        state.errortriggerpallascdc = null;
    })
    .addCase(triggerPallasAlgoCdc.fulfilled, (state, action) => {
        state.triggerpallascdcLoading = false;
        state.triggerpallascdc = action.payload;
    })
    .addCase(triggerPallasAlgoCdc.rejected, (state, action) => {
        state.triggerpallascdcLoading = false;
        state.errortriggerpallascdc = action.payload;
    })
    
    .addCase(getAuditResponse.pending, (state) => {
        state.auditStatusState.auditStatusLoading = true;
        state.auditStatusState.auditStatusStateError= null;
    })
    .addCase(getAuditResponse.fulfilled, (state, action) => {
        state.auditStatusState.auditStatusLoading = false;
        state.auditStatusState.auditStatusStateData = action.payload;
    })
    .addCase(getAuditResponse.rejected, (state, action) => {
        state.auditStatusState.auditStatusLoading = false;
        state.auditStatusState.auditStatusStateError = action.payload;
    })
    .addCase(fetchClusterWarnings.pending, (state) => {
        state.clusterCodeWarnings.clusterCodeWarningsIsLoading = true;
        state.clusterCodeWarnings.clusterCodeWarningsError= null;
    })
    .addCase(fetchClusterWarnings.fulfilled, (state, action) => {
        state.clusterCodeWarnings.clusterCodeWarningsIsLoading = false;
        state.clusterCodeWarnings.clusterCodeWarningsList = action.payload;
    })
    .addCase(fetchClusterWarnings.rejected, (state, action) => {
        state.clusterCodeWarnings.clusterCodeWarningsIsLoading = false;
        state.clusterCodeWarnings.clusterCodeWarningsError = action.payload;
    })
    .addCase(fetchCodeAssistCancerWarnings.pending, (state) => {
        state.cancerCodeWarnings.cancerCodeWarningsIsLoading = true;
        state.cancerCodeWarnings.cancerCodeWarningsError= null;
    })
    .addCase(fetchCodeAssistCancerWarnings.fulfilled, (state, action) => {
        state.cancerCodeWarnings.cancerCodeWarningsIsLoading = false;
        state.cancerCodeWarnings.cancerCodeWarningsList = action.payload;
    })
    .addCase(fetchCodeAssistCancerWarnings.rejected, (state, action) => {
        state.cancerCodeWarnings.cancerCodeWarningsIsLoading = false;
        state.cancerCodeWarnings.cancerCodeWarningsError = action.payload;
    })
        .addCase(getAuditorNamesAndQueues.pending, (state) => {
          state.loadingAuditorNamesandQueues = true;
          state.errorsauditorNamesandQueues = null;
        })
        .addCase(getAuditorNamesAndQueues.fulfilled, (state, action) => {
          state.loadingAuditorNamesandQueues = false;
          state.auditorNamesandQueues = action.payload;
          console.log("coderQueuesData queues data",action.payload);
        })
        .addCase(getAuditorNamesAndQueues.rejected, (state, action) => {
          state.loadingAuditorNamesandQueues = false;
          state.errorsauditorNamesandQueues = action.payload;
        })
        .addCase(getCoderNamesInActions.pending, (state) => {
          state.loadingcoderNamesInActions = true;
          state.errorcoderNamesInActions = null;
        })
        .addCase(getCoderNamesInActions.fulfilled, (state, action) => {
          state.loadingcoderNamesInActions = false;
          state.coderNamesInActions = action.payload;
          console.log("coderQueuesData queues data",action.payload);
        })
        .addCase(getCoderNamesInActions.rejected, (state, action) => {
          state.loadingcoderNamesInActions = false;
          state.errorcoderNamesInActions = action.payload;
        })
},
});
export const { setDocumentationCard, setCodingScreenCard, setCodeBookCard, setRangeChildren, setClusterIDs, setcurrentClusterID, setNextClusterIDs, setClusterCodeWarningsList, setCancerCodeWarningsList, setEnableMissingNotes, setSelectedMissingNotesOptions, resetSelectedMissingNotesOptions, setShowMissningNotesDropdown,setIsPallasAlgoApplied,resetIsPallasAlgoApplied } = coderSlicer.actions;

export default coderSlicer.reducer